import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnDestroy,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { FileService } from '@ipg/ngx-frontend-toolset';
import { DataTableContainerComponent } from '../../../../components/data-table-container/data-table-container.component';
import { FilesizePipe } from '../../../../pipes/filesize.pipe';
import { SecondsToDurationPipe } from '../../../../pipes/seconds-to-duration.pipe';
import { AudioPlayerService } from '../../../../services/audio-player.service';
import {
  SignalingAudioBlock,
  SignalingAudioBlockData,
} from '../../client-signaling.model';

@Component({
  selector: 'app-signaling-block-audio-table',
  imports: [
    MatIcon,
    MatIconButton,
    MatTableModule,
    MatTooltip,
    DataTableContainerComponent,
    FilesizePipe,
    SecondsToDurationPipe,
  ],
  templateUrl: './signaling-block-audio-table.component.html',
  styleUrl: './signaling-block-audio-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalingBlockAudioTableComponent implements OnDestroy {
  private readonly _fileService = inject(FileService);
  private readonly _audioPlayerService = inject(AudioPlayerService);

  protected readonly currentTrackId = computed(
    () => this._audioPlayerService.currentTrack()?.id
  );
  protected readonly isPlaying = computed(
    () => this._audioPlayerService.state().playing
  );

  dataSource = input<SignalingAudioBlock['data']>([]);

  hideActions = input(false, { transform: booleanAttribute });

  displayedColumns = ['name', 'size', 'duration', 'actions'];

  itemRemove = output<string>();

  handleAudioPlayback({ label, fileId, linkId }: SignalingAudioBlockData) {
    const url = this._fileService.get(fileId).href;

    if (this.currentTrackId() === linkId) {
      this._audioPlayerService.stop();

      return;
    }

    const track = {
      id: linkId,
      title: label,
      src: url,
    };

    this._audioPlayerService.load(track);
    this._audioPlayerService.play();
  }

  handleItemRemove(linkId: string) {
    this.itemRemove.emit(linkId);

    this._audioPlayerService.stop();
  }

  ngOnDestroy() {
    this._audioPlayerService.stop();
  }
}
